import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

const buttonThemes = {
  blue: { color: "#282A52", bg: "#E5E9F0", hover: "#2b3082" },
  blueSecondary: { color: "#E5E9F0", bg: "#282A52", hover: "#2b3082" },
  green: { bg: "#E5F0E9", color: "#285236", hover: "#acd2b9" },
  greenSecondary: { color: "#E5F0E9", bg: "#285236", hover: "#2b8248" },
  red: { bg: "#F0E5E5", color: "#522828", hover: "#d2acac" },
  redSecondary: { bg: "#522828", color: "#F0E5E5", hover: "#822b2b" },
  cyan: { bg: "#E5ECF0", color: "#284452", hover: "#acc6d2" },
  cyanSecondary: { bg: "#284452", color: "#E5ECF0", hover: "#2b6582" },
  lightblue: { bg: "#E5E5F0", color: "#282852", hover: "#acacd2" },
  lightblueSecondary: { bg: "#282852", color: "#E5E5F0", hover: "#2b2b82" },
  greenV1: { bg: "#E9F0E5", color: "#365228", hover: "#B9D2AC" },
  greenV1Secondary: { bg: "#365228", color: "#E9F0E5", hover: "#48822B" },
};

const themes = {
  default: {
    bg: "#E5E9F0",
    text: "#282A52",
    button: buttonThemes["blue"],
    buttonSecondary: buttonThemes["blueSecondary"],
    icon: { color: "#E5E9F0", hover: "#2b3082" },
    border: "#acb9d2",
    transparent: "rgba(229, 233, 240, 0.72)",
    name: "default",
    textHover: "#2b3082",
  },
  technician: {
    bg: "#E5F0E9",
    text: "#285236",
    button: buttonThemes["green"],
    buttonSecondary: buttonThemes["greenSecondary"],
    icon: { color: "#E5F0E9", hover: "#2b8248" },
    sticky: { bg: "#285236", text: "#E5F0E9", hover: "#1A6738" },
    border: "#acd2b9",
    transparent: "rgba(229, 240, 233, 0.72)",
    name: "technician",
    textHover: "#2b3082",
  },
  storekeeper: {
    bg: "#F0E5E5",
    text: "#522828",
    button: buttonThemes["red"],
    buttonSecondary: buttonThemes["redSecondary"],
    icon: { color: "#F0E5E5", hover: "#4169e1" },
    sticky: { bg: "#284452", text: "#F0E5E5", hover: "#3159C1" },
    border: "#d2acac",
    transparent: "rgba(240, 229, 229, 0.72)",
    name: "storekeeper",
    textHover: "#2b3082",
  },
  manager: {
    bg: "#E5ECF0",
    text: "#284452",
    button: buttonThemes["cyan"],
    buttonSecondary: buttonThemes["cyanSecondary"],
    icon: { color: "#E5ECF0", hover: "#2b6582" },
    sticky: { bg: "#284452", text: "#E5ECF0", hover: "#1F5570" },
    border: "#acc6d2",
    transparent: "rgba(229, 236, 240, 0.72)",
    name: "manager",
    textHover: "#2b3082",
  },
  inspector: {
    bg: "#E5E5F0",
    text: "#282852",
    button: buttonThemes["lightblue"],
    buttonSecondary: buttonThemes["lightblueSecondary"],
    icon: { color: "#E5E5F0", hover: "#2b6582" },
    sticky: { bg: "#282852", text: "#E5E5F0", hover: "#1F5570" },
    border: "#acacd2",
    transparent: "rgba(229, 229, 240, 0.72)",
    name: "inspector",
    textHover: "#2b3082",
  },
  lifeScience: {
    bg: "#E5E5F0",
    text: "#282852",
    button: buttonThemes["lightblue"],
    buttonSecondary: buttonThemes["lightblueSecondary"],
    icon: { color: "#282852", hover: "#2B2B82" },
    sticky: { bg: "#282852", text: "#E5E5F0", hover: "#1D1D5A" },
    border: "#ACACD2",
    transparent: "rgba(229, 229, 240, 0.72)",
    name: "lifeScience",
    base: "#e5e5f0",
    textHover: "#2b3082",
    title: "Life sciences",
  },
  utilities: {
    bg: "#E5ECF0",
    text: "#284452",
    button: buttonThemes["cyan"],
    buttonSecondary: buttonThemes["cyanSecondary"],
    icon: { color: "#282852", hover: "#2B2B82" },
    sticky: { bg: "#284452", text: "#E5ECF0", hover: "#1D1D5A" },
    border: "#ACC6D2",
    transparent: "rgba(229, 236, 240, 0.72)",
    name: "utilities",
    base: "#e5ecf0",
    textHover: "#2b6582",
    title: "Utilities",
  },
  facilities: {
    bg: "#E9F0E5",
    text: "#365228",
    button: buttonThemes["greenV1"],
    buttonSecondary: buttonThemes["greenV1Secondary"],
    icon: { color: "#282852", hover: "#2B2B82" },
    sticky: { bg: "#365228", text: "#E9F0E5", hover: "#1D1D5A" },
    border: "#b9d2ac",
    transparent: "rgba(233, 240, 229, 0.72)",
    name: "facilities",
    base: "#e9f0e5",
    textHover: "#48822B",
    title: "Fatilities",
  },
  manufacturing: {
    bg: "#F0E5E5",
    text: "#522828",
    button: buttonThemes["red"],
    buttonSecondary: buttonThemes["redSecondary"],
    icon: { color: "#282852", hover: "#2B2B82" },
    sticky: { bg: "#522828", text: "#F0E5E5", hover: "#1D1D5A" },
    border: "#D2ACAC",
    transparent: "rgba(240, 229, 229, 0.72)",
    name: "manufacturing",
    base: "#f0e5e5",
    textHover: "#822b2b",
    title: "Energy & Manufacturing",
  },
};

export const ThemeProvider = ({ children, themeClass = "default" }) => {
  const [buttonTheme, setbuttonTheme] = useState(buttonThemes);
  const [headerPanel, setHeaderPanel] = useState(false);
  const [theme, setTheme] = useState(null);
  
 
  

 
  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        themes,
        headerPanel,
        setHeaderPanel,
        buttonTheme,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);
